import { render, staticRenderFns } from "./pixijs.vue?vue&type=template&id=035ad84a"
import script from "./pixijs.vue?vue&type=script&lang=js"
export * from "./pixijs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports